module.exports = __webpack_public_path__ + "img/Cart.c7f09b6b.svg";